import type { Job } from "../types";

export const DOSSIER_TYPE_LABELS: Record<NonNullable<Job["dossierType"]>, string> = {
  led: "LED",
  led_exterieur: "LED extérieur",
  led_interieur: "LED intérieur",
  deshumidificateur: "Déshumidificateur",
  vmc_agricoles: "VMC Agricoles",
  th_122: "TH 122",
  renovation: "Rénovation",
  hp_bp_flottante: "HP/BP flottante",
  pac: "PAC",
};

type DossierTypeInput = Job["dossierType"] | undefined | "" | null;

export const isPacDossierType = (value: DossierTypeInput): boolean => value === "pac";

export const usesRenovationQuestions = (value: DossierTypeInput): boolean =>
  value === "renovation" || value === "hp_bp_flottante" || value === "pac";

export const usesTechnicalQuestions = (value: DossierTypeInput): boolean =>
  !usesRenovationQuestions(value);

export const showLedTechnicalFields = (value: DossierTypeInput): boolean =>
  value === "led_exterieur" ||
  value === "led_interieur" ||
  value === "led" ||
  !value;

export const showDehumidifierTechnicalFields = (value: DossierTypeInput): boolean =>
  value === "deshumidificateur" ||
  value === "vmc_agricoles";

export const showTimerTechnicalFields = (value: DossierTypeInput): boolean =>
  value === "th_122";

export const buildClientNameForDossierType = (
  dossierType: DossierTypeInput,
  fields: { clientName: string; clientFirstName: string; clientLastName: string }
): string => {
  if (usesRenovationQuestions(dossierType)) {
    const fromParts = `${fields.clientLastName} ${fields.clientFirstName}`.trim();
    if (fromParts) return fromParts;
  }
  return fields.clientName.trim();
};

export function getDossierTypeLabel(
  dossierType: Job["dossierType"] | undefined | null
): string | null {
  if (!dossierType) return null;
  return DOSSIER_TYPE_LABELS[dossierType] ?? dossierType;
}

export function getLightingTypeLabel(
  lightingType: string | undefined | null
): string | null {
  if (!lightingType?.trim()) return null;
  if (lightingType === "visite technique") return "Visite technique";
  if (lightingType === "pose") return "Pose";
  return lightingType;
}
